export default __webpack_public_path__ + "static/media/upgrad_logo_red.24a0e93b.png";